/**
 * @generated SignedSource<<a54a0c3da52563333ebf58846fa14657>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SudoSwitchUserMutationInput = {
  clientMutationId?: string | null;
  email: string;
  jwtType: string;
};
export type SudoSwitchUserMutation$variables = {
  input: SudoSwitchUserMutationInput;
};
export type SudoSwitchUserMutation$data = {
  readonly sudoSwitchUser: {
    readonly clientMutationId: string | null;
  } | null;
};
export type SudoSwitchUserMutation = {
  variables: SudoSwitchUserMutation$variables;
  response: SudoSwitchUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SudoSwitchUserMutationPayload",
    "kind": "LinkedField",
    "name": "sudoSwitchUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SudoSwitchUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SudoSwitchUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4d494ba757a3f6fa74982dd8a09d0a3f",
    "id": null,
    "metadata": {},
    "name": "SudoSwitchUserMutation",
    "operationKind": "mutation",
    "text": "mutation SudoSwitchUserMutation(\n  $input: SudoSwitchUserMutationInput!\n) {\n  sudoSwitchUser(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "67e3ff6aadd8a7e838d7154100b9826f";

export default node;
